/**
 * this controller was moved from index, when we moved to SPA we need to fix it, try to add to the route
 * @param $scope
 * @param loginService
 * @param gettextCatalog
 */
function loginController($scope, loginService, gettextCatalog) {
    const vm = this;

    $scope.init = function() {
        loginService.initIndex()
            .then(response => {
                vm.appVersion = response.version + ' ' + response.buildDate;
                const localeString = response.locale;
                 if (localeString) {
                     const scriptTag = document.createElement('script');
                     const source = 'i18n/angular-locale_' + localeString.toString().toLowerCase().replace('_', '-') + '.js';
                     scriptTag.setAttribute('src', source);
                     angular.element(document.head)[0].append(scriptTag);
                }
            })
            .catch(reason => {
                vm.error = reason.error;
            });
    };

    vm.login = function(form) {
        if (form) {
            const user = {username: form.username, password: form.password};
            loginService.login(user)
                .then(response => response)
                .catch(data => {
                    if (data.code === 'qkr2apiserver.unexpected.error') {
                        vm.error = gettextCatalog.getString('Sorry, an unexpected error occurred.');
                    } else {
                        vm.error = gettextCatalog.
                            getString('Sorry, we were not able to find a user with that email and password.');
                        if (data.error) {
                            vm.error = data.error;
                        }
                    }
                });
        } else { // occurs when no username specified
            vm.error = gettextCatalog.getString('Please enter email and password fields.');
        }
    };

    vm.isCamelCase = function(amICamelCase) {
        if (!amICamelCase) {
            return false;
        }
        return amICamelCase.toLowerCase() !== amICamelCase;
    };
}
angular.module('qkr').controller('LoginController', loginController);


// WEBPACK FOOTER //
// ./src/login/login.controller.js